import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, input, OnInit, output, signal, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { ContentReadyEvent, RowClickEvent } from 'devextreme/ui/data_grid';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: 'app-form-list',
    imports: [CommonModule, DxDataGridModule],
    template: `
    <div class="view-wrapper list-page crm-contact-list">
      <dx-data-grid
        class="grid theme-dependent"
        noDataText=""
        height="100%"
        [dataSource]="dataSource()"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [columnHidingEnabled]="true"
        [focusedRowEnabled]="true"
        [showBorders]="true"
        [keyExpr]="keyExpr()"
        (onRowClick)="rowClick($event)"
        (onExporting)="onExporting($event)"
        (onContentReady)="contentReady($event)"
      >
        <dxo-load-panel [showPane]="false"></dxo-load-panel>
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-selection selectAllMode="allPages" showCheckBoxesMode="always" mode="multiple"></dxo-selection>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        <dxo-state-storing [enabled]="true" [storageKey]="storageKey()"></dxo-state-storing>
        <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
        <dxo-export [enabled]="true" [allowExportSelectedData]="true"> </dxo-export>

        <dxo-toolbar>
          <dxi-item location="before">
            @if (header()) {
            <div class="grid-header">{{ header() }}</div>
            }
          </dxi-item>
          <dxi-item
            location="after"
            locateInMenu="auto"
            showText="inMenu"
            widget="dxButton"
            [options]="{
              text: 'Refresh',
              hint: 'Refresh',
              icon: 'refresh',
              onClick: refresh,
              stylingMode: 'text'
            }"
          ></dxi-item>
          <dxi-item
            location="after"
            locateInMenu="auto"
            showText="inMenu"
            widget="dxButton"
            [options]="{
              text: 'Reset Grid',
              hint: 'Reset Grid',
              icon: 'revert',
              stylingMode: 'text',
              onClick: resetGrid
            }"
          ></dxi-item>
          <dxi-item location="after" locateInMenu="auto">
            <div class="separator"></div>
          </dxi-item>
          <!-- <dxi-item name="exportButton"></dxi-item>
          <dxi-item location="after" locateInMenu="auto">
            <div class="separator"></div>
          </dxi-item> -->
          <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
          <dxi-item name="searchPanel" locateInMenu="auto"></dxi-item>
        </dxo-toolbar>
      </dx-data-grid>
    </div>
  `,
    styles: [
        `
      @use '../../../../variables.scss' as *;
      @use 'sass:math';

      :host {
        --side-panel-toolbar-height: 76px;

        width: 100%;
        display: contents;
      }

      .view-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        flex-direction: row;

        .grid {
          .name-template {
            .position {
              font-size: 12px;
              color: var(--texteditor-label-color);
            }
          }

          ::ng-deep & {
            .dx-datagrid-header-panel {
              padding: 0 var(--content-padding);
            }

            .dx-toolbar {
              margin-bottom: 0;
              padding: var(--toolbar-margin-bottom) 0;
            }

            .dx-datagrid-content .dx-row {
              cursor: pointer;
            }
          }

          .grid-header {
            @include header();
          }
        }

        user-panel {
          display: inherit;
        }
      }
    `
    ]
})
export class FormListComponent {
  formService = inject(FormService);
  router = inject(Router);

  form = input.required<string>();
  keyExpr = input<string>('id');
  header = input<string>();
  // storageKey = input<string>();
  detailUrl = input<string>();
  onContentReady = output<ContentReadyEvent>();

  storageKey = computed(() => this.form + '-list');

  dataGrid = viewChild(DxDataGridComponent);
  dataSource = signal<any[]>([]);

  constructor() {
    effect(async () => {
      const result = await this.formService.list(this.form());
      const data = result.isSuccess ? result.value : [];
      this.dataSource.set(data);
    });
  }
  contentReady = (e: ContentReadyEvent) => {
    e.component.instance().columnOption(this.keyExpr(), 'visible', false);
    this.onContentReady.emit(e);
  };

  refresh = () => {
    this.dataGrid().instance.refresh();
  };

  rowClick = (e: RowClickEvent) => {
    const key = e.key;
    if (!key || !this.detailUrl()) return;
    this.router.navigate([`${this.detailUrl()}/${key}`]);
  };

  onExporting = (e) => {
    console.log('onExporting', e);
  };

  resetGrid = () => {
    this.dataGrid().instance.state(null);
  };
}
